import { FC, useState } from "react";
import { Tabs, Breadcrumb } from "flowbite-react";
import { HiCog, HiHome, HiKey, HiOfficeBuilding, HiSparkles } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import NavbarSidebarLayout from "../../layouts/navbar-sidebar";
import AIAgentConfigTab from "./AIAgentConfigTab";
import CompanyInfoTab from "./CompanyInfoTab";
import SsoSettingsTab from "./SsoSettingsTab";

const CompanySettingsPage: FC = () => {
  const { t } = useTranslation(["companySetting"]);

  const [activeTab, setActiveTab] = useState<number>(() => {
    const saved = localStorage.getItem("companySettingsActiveTab");
    return saved ? parseInt(saved, 10) : 0;
  });

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    localStorage.setItem("companySettingsActiveTab", index.toString());
  };

  return (
    <NavbarSidebarLayout>
      <div className="px-4 pt-6 pb-12">
        <Breadcrumb className="mb-4">
          <Breadcrumb.Item href="/">
            <div className="flex items-center gap-x-3">
              <HiHome className="text-xl" />
              <span className="dark:text-white">{t("companySetting:home")}</span>
            </div>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <div className="flex items-center gap-x-2">
              <HiCog />
              <span>{t("companySetting:title")}</span>
            </div>
          </Breadcrumb.Item>
        </Breadcrumb>

        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">
          {t("companySetting:title")}
        </h1>

        <Tabs
          aria-label="Company settings tabs"
          variant="pills"
          onActiveTabChange={handleTabChange}
          theme={{
            tablist: {
              base: "flex text-center justify-center",
              tabitem: {
                variant: {
                  pills: {
                    active: {
                      on: "rounded-full bg-gray-300 dark:bg-blue-900 text-black dark:text-white",
                      off: "rounded-full hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-white",
                    },
                  },
                },
              },
            },
          }}
        >
          <Tabs.Item
            active={activeTab === 0}
            title={t("companySetting:aiAgent.tab")}
            icon={HiSparkles}
          >
            <AIAgentConfigTab />
          </Tabs.Item>
          <Tabs.Item
            active={activeTab === 1}
            title={t("companySetting:company.tab")}
            icon={HiOfficeBuilding}
          >
            <CompanyInfoTab />
          </Tabs.Item>
          <Tabs.Item
            active={activeTab === 2}
            title={t("companySetting:sso.tab")}
            icon={HiKey}
          >
            <SsoSettingsTab />
          </Tabs.Item>
        </Tabs>
      </div>
    </NavbarSidebarLayout>
  );
};

export default CompanySettingsPage;
